import React, { useState, useEffect } from 'react';
import { Search, Trash2, Edit, Plus, Save, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import config from '../config';

const CompanyManagement = () => {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [search, setSearch] = useState('');
  const [formData, setFormData] = useState({
    CompanyName: '',
    CompanyCode: '',
    PhoneNumber: '',
    Address: '',
    Email: ''
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchCompanies();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        // تحديث شركة موجودة
        const response = await fetch(`${config.API_BASE_URL}/api/companies/${editingId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || 'حدث خطأ أثناء تحديث الشركة');
        }
        
        alert('تم تحديث الشركة بنجاح');
      } else {
        // إضافة شركة جديدة
        const response = await fetch(`${config.API_BASE_URL}/api/companies`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || 'حدث خطأ أثناء إضافة الشركة');
        }
        
        alert('تم إضافة الشركة بنجاح');
      }
      
      await fetchCompanies();
      resetForm();
    } catch (error) {
      console.error('خطأ:', error);
      alert('حدث خطأ: ' + error.message);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/companies`);
      if (!response.ok) {
        throw new Error('فشل في جلب بيانات الشركات');
      }
      const data = await response.json();
      console.log('تم استلام البيانات:', data);
      setCompanies(data);
    } catch (error) {
      console.error('خطأ في جلب الشركات:', error);
      alert('حدث خطأ في جلب بيانات الشركات');
    }
  };

  const handleEdit = (company) => {
    setFormData({
      CompanyName: company.CompanyName,
      CompanyCode: company.CompanyCode || '',
      PhoneNumber: company.PhoneNumber || '',
      Address: company.Address || '',
      Email: company.Email || ''
    });
    setEditingId(company.CompanyID);
    setShowForm(true);
  };

  const handleDelete = async (companyId) => {
    if (window.confirm('هل أنت متأكد من حذف هذه الشركة؟')) {
      try {
        await fetch(`${config.API_BASE_URL}/api/companies/${companyId}`, {
          method: 'DELETE'
        });
        fetchCompanies();
      } catch (error) {
        console.error('خطأ في حذف الشركة:', error);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      CompanyName: '',
      CompanyCode: '',
      PhoneNumber: '',
      Address: '',
      Email: ''
    });
    setEditingId(null);
    setShowForm(false);
  };

  const goBack = () => {
    navigate('/');
  };

  const filteredCompanies = companies.filter(company =>
    company.CompanyName.toLowerCase().includes(search.toLowerCase()) ||
    company.CompanyCode?.toLowerCase().includes(search.toLowerCase()) ||
    company.Email?.toLowerCase().includes(search.toLowerCase()) ||
    company.Address?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container mx-auto p-3 md:p-4 text-right overflow-x-hidden" dir="rtl">
      <div className="bg-white rounded-2xl md:rounded-lg shadow-lg p-4 md:p-6 mb-6">
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-4 md:mb-6">
          <div>
            <p className="md:hidden text-xs text-blue-600 font-semibold mb-1">مسار / الشركات</p>
            <h1 className="text-xl md:text-2xl font-bold">إدارة الشركات</h1>
            <p className="md:hidden text-sm text-gray-500 mt-1">إجمالي {filteredCompanies.length} شركة</p>
          </div>
          <button 
            onClick={goBack}
            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-xl md:rounded w-full md:w-auto"
          >
            العودة للرئيسية
          </button>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-4">
          <button 
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-3 md:py-2 rounded-xl md:rounded flex items-center justify-center gap-2 w-full md:w-auto font-semibold"
            onClick={() => setShowForm(true)}
          >
            <Plus size={16} />
            إضافة شركة جديدة
          </button>
          <div className="relative w-full md:w-64">
            <Search className="absolute right-2 top-2 h-4 w-4 text-gray-500" />
            <input
              type="text"
              placeholder="بحث..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full border rounded-xl md:rounded py-3 md:py-2 px-8 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {showForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-stretch md:items-center justify-center z-50 md:p-4">
            <div className="bg-white rounded-none md:rounded-lg p-4 md:p-6 w-full md:max-w-2xl md:mx-4 h-[100dvh] md:h-auto overflow-y-auto">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">
                  {editingId ? 'تعديل الشركة' : 'إضافة شركة جديدة'}
                </h2>
                <button
                  onClick={resetForm}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X size={24} />
                </button>
              </div>
              
              <form onSubmit={handleSubmit} className="space-y-4 pb-24 md:pb-0">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">اسم الشركة</label>
                    <input
                      type="text"
                      value={formData.CompanyName}
                      onChange={(e) => setFormData({...formData, CompanyName: e.target.value})}
                      className="w-full border rounded p-2"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">رمز الشركة </label>
                    <input
                      type="text"
                      value={formData.CompanyCode}
                      onChange={(e) => setFormData({...formData, CompanyCode: e.target.value.replace(/\s+/g, '').toUpperCase()})}
                      className="w-full border rounded p-2"
                      placeholder="مثال: N أو KSA أو COMP1"
                      maxLength={30}
                    />
                    <p className="text-xs text-gray-500 mt-1">سيظهر في الباركود بدل C قبل رقم الـ ID.</p>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium mb-1">رقم الهاتف</label>
                    <input
                      type="text"
                      value={formData.PhoneNumber}
                      onChange={(e) => setFormData({...formData, PhoneNumber: e.target.value})}
                      className="w-full border rounded p-2"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium mb-1">العنوان</label>
                    <input
                      type="text"
                      value={formData.Address}
                      onChange={(e) => setFormData({...formData, Address: e.target.value})}
                      className="w-full border rounded p-2"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium mb-1">البريد الإلكتروني</label>
                    <input
                      type="email"
                      value={formData.Email}
                      onChange={(e) => setFormData({...formData, Email: e.target.value})}
                      className="w-full border rounded p-2"
                    />
                  </div>
                </div>

                <div className="fixed md:static bottom-0 left-0 right-0 bg-white border-t md:border-t-0 p-3 md:p-0 flex flex-col-reverse md:flex-row justify-end gap-2 mt-4">
                  <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-3 md:py-2 rounded-xl md:rounded flex items-center justify-center gap-2 w-full md:w-auto"
                  >
                    <Save size={16} />
                    {editingId ? 'تحديث' : 'حفظ'}
                  </button>
                  <button
                    type="button"
                    onClick={resetForm}
                    className="border border-gray-300 hover:bg-gray-50 px-4 py-3 md:py-2 rounded-xl md:rounded w-full md:w-auto"
                  >
                    إلغاء
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {companies.length === 0 ? (
          <div className="bg-blue-50 text-blue-700 p-4 rounded-lg">
            لا يوجد شركات مضافة حالياً
          </div>
        ) : (
          <>
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border p-2 text-right">اسم الشركة</th>
                  <th className="border p-2 text-right">رمز الشركة  </th>
                  <th className="border p-2 text-right">رقم الهاتف</th>
                  <th className="border p-2 text-right">العنوان</th>
                  <th className="border p-2 text-right">البريد الإلكتروني</th>
                  <th className="border p-2 text-right">الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                {filteredCompanies.map((company) => (
                  <tr key={company.CompanyID} className="hover:bg-gray-50">
                    <td className="border p-2">{company.CompanyName}</td>
                    <td className="border p-2"><span className="inline-flex px-2 py-1 rounded bg-indigo-50 text-indigo-700 font-bold">{company.CompanyCode || 'C'}</span></td>
                    <td className="border p-2">{company.PhoneNumber}</td>
                    <td className="border p-2">{company.Address}</td>
                    <td className="border p-2">{company.Email}</td>
                    <td className="border p-2">
                      <div className="flex gap-2 justify-center">
                        <button
                          onClick={() => handleEdit(company)}
                          className="text-blue-500 hover:text-blue-700"
                          title="تعديل"
                        >
                          <Edit size={16} />
                        </button>
                        <button
                          onClick={() => handleDelete(company.CompanyID)}
                          className="text-red-500 hover:text-red-700"
                          title="حذف"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
            <div className="md:hidden space-y-3 mt-4">
              {filteredCompanies.map((company) => (
                <div key={company.CompanyID} className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
                  <div className="h-1.5 bg-gradient-to-l from-blue-500 to-indigo-500" />
                  <div className="p-4 space-y-3">
                    <div className="flex justify-between items-start gap-3">
                      <div className="min-w-0">
                        <h3 className="font-bold text-gray-900 text-base break-words">{company.CompanyName}</h3>
                        <p className="text-xs text-gray-500 mt-1">شركة خارجية / جهة تعامل</p>
                        <p className="text-xs text-indigo-700 mt-1 font-bold">رمز الشركة  : {company.CompanyCode || 'C'}</p>
                      </div>
                      <span className="shrink-0 text-xs bg-blue-50 text-blue-700 border border-blue-100 px-2 py-1 rounded-full">نشط</span>
                    </div>
                    <div className="grid grid-cols-1 gap-2 text-sm">
                      <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">رمز الشركة  : </span><span className="font-bold text-indigo-700">{company.CompanyCode || 'C'}</span></div>
                      <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">الهاتف: </span><span className="font-medium">{company.PhoneNumber || '-'}</span></div>
                      <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">العنوان: </span><span className="font-medium break-words">{company.Address || '-'}</span></div>
                      <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">البريد: </span><span className="font-medium break-all">{company.Email || '-'}</span></div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 pt-1">
                      <button onClick={() => handleEdit(company)} className="bg-blue-50 text-blue-700 border border-blue-100 rounded-xl py-2.5 flex items-center justify-center gap-2 font-semibold">
                        <Edit size={16} /> تعديل
                      </button>
                      <button onClick={() => handleDelete(company.CompanyID)} className="bg-red-50 text-red-700 border border-red-100 rounded-xl py-2.5 flex items-center justify-center gap-2 font-semibold">
                        <Trash2 size={16} /> حذف
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CompanyManagement;